// Normalizes data from the bookings /api/public/directory endpoint and the
// legacy static locationsData.js file into the same flat shape consumed by
// OfficeLocationsCentersSection.

function formatPhone(e164) {
  if (!e164) return null;
  const match = e164.match(/^(\+\d{2})(\d{3})(\d{3})(\d{3})$/);
  return match ? `${match[1]} ${match[2]} ${match[3]} ${match[4]}` : e164;
}

export function adaptDirectory(apiResponse) {
  const centers = apiResponse?.centers ?? [];
  return centers
    .filter((c) => c.isActive)
    .map((c) => ({
      name: c.name,
      province: c.province ?? 'Otros',
      contact: c.admin?.name ?? null,
      phone: formatPhone(c.contactPhone),
      services: (c.services ?? []).map((s) => s.name),
      link: c.mapsUrl ?? null,
    }));
}

export function flattenStatic(locationsByProvince) {
  return locationsByProvince.flatMap((group) =>
    group.locations.map((loc) => ({
      name: loc.name,
      province: group.province,
      contact: loc.contact ?? null,
      phone: loc.phone ?? null,
      services: loc.services ?? [],
      link: loc.link ?? null,
    }))
  );
}
